export const ACTION = {
    GET_GLOSSARY_DATA:'GET_GLOSSARY_DATA',
    GET_GLOSSARY_ALPHABET:'GET_GLOSSARY_ALPHABET',
};